// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"2f8b1368","271":"29fff64c","340":"25d4f226","641":"8e2a1eb1","816":"d0b65e6d"}[chunkId] + ".chunk.js";
};